import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BannerBlock from '../components/complex/bannerBlock/bannerBlock';
import SEO from '../utils/SEO';
import './../assets/styles/pages/_press-inner.scss';
import StackGrid from '../components/complex/imageGrid/_imageGrid';
import { connect } from 'react-redux';
import { userActions } from '../redux/actions';
import GoBack from '../components/common/goBack/goBack';
import MediaHeader from '../components/complex/mediaHeader/mediaHeader';
import { startLoader } from '../components/common/Loader';
import PopupWithSLider from '../components/complex/popupWithSlider/popupWithSlider';
import { Link } from 'react-router-dom';
import PageNotFound from './notFound';

function PressInner ({ press_list, press_inner, ...props }) {
  function goBack () {
    props.history.goBack();
  }

  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    props.getMeta('Press Accreditation Form');
    startLoader();
    props.getPress();
  }, []);

  useEffect(() => {
    props.getPressInnerData(props.match.params.url);
    // startLoader();
  }, [props.match.params.url]);
  const metaData = props.metaData?.res;
  const banner = press_list?.items?.res.banner;
  const pressUrl = props.match.params.url;
  const pressList = press_list && press_list.items && press_list.items.res.data;
  const currentPress =
    press_inner && press_inner?.items && press_inner?.items?.data;

  const pressMediaUrl = props.match.params.media;
  let gallery;

  // if (press_inner && press_inner?.items?.data) {
  switch (pressMediaUrl) {
    case 'media_all':
      if (press_inner.error) {
        return <PageNotFound loader={false} />;
      } else if (currentPress && currentPress.data) {
        gallery = currentPress && currentPress.data;
      }
      break;
    case 'photos':
      if (press_inner.error) {
        return <PageNotFound loader={false} />;
      } else if (currentPress && currentPress.data.length) {
        gallery =
          currentPress && currentPress.data.filter((el) => el.type === 'image');
      }

      break;
    case 'videos':
      if (press_inner.error) {
        return <PageNotFound loader={false} />;
      } else if (currentPress && currentPress.data.length) {
        gallery =
          currentPress && currentPress.data.filter((el) => el.type === 'video');
      }

      break;
    default:
      return <PageNotFound loader={false} />;
  }
  // }

  const indexOfNextProject = 0;
  const indexOfPrevProject = 0;

  let nextProject = pressList && pressList[indexOfNextProject];
  let prevProject = pressList && pressList[indexOfPrevProject];

  // const project =
  //   pressList &&
  //   pressList.find((project, index) => {
  //     indexOfNextProject = index + 1;
  //     indexOfPrevProject = index - 1;

  //     indexOfPrevProject =
  //       indexOfPrevProject < 0 ? pressList.length - 1 : indexOfPrevProject;
  //     //
  //     return project.id === parseInt(props.match.params.url);
  //   });
  // console.log(project);

  if (pressList && pressList[indexOfNextProject]) {
    nextProject = pressList[indexOfNextProject];
  }

  if (pressList && pressList[indexOfPrevProject]) {
    prevProject = pressList[indexOfPrevProject];
  }
  const ifVideos =
    currentPress && currentPress.data.filter((el) => el.type === 'video');

  return (
    <>
      {props.press_inner?.error && <PageNotFound loader={false} />}
      <SEO
        title={currentPress && currentPress.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
      <SEO description='FAQ DESCRIPTION' img='' />
      <BannerBlock
        data={banner && banner}
        pageName='pressBanner'
        fullHeight
        // pressPage
        color='white'
        position='left'
        scrollTo={{ elementId: 'press-inner' }}
      />
      <div id='press-inner' className='press-inner'>
        {currentPress && (
          <PopupWithSLider
            data={gallery && gallery}
            setSwiper={(swiper) => setSwiper(swiper)}
          />
        )}
        <GoBack goBack={goBack} />
        <h4 className='press-inner-title'>
          {currentPress && currentPress.title}
        </h4>
        <h5 className='press-inner-year'>
          {currentPress && currentPress.year}
        </h5>
        <MediaHeader
          url={pressUrl}
          media={pressMediaUrl}
          gallery={ifVideos && ifVideos}
        />

        <div className='content'>
          {currentPress &&
            (gallery.length !== 0 ? (
              <StackGrid
                src={gallery}
                swiper={swiper}
                mediaUrl={props.match.params.media}
              />
            ) : (
              <div>
                <h4 className='press-inner-title'>
                  VIDEOS ARE NOT AVAILABLE YET !
                </h4>
              </div>
            ))}
          <div className='press-inner-navigation'>
            <ul className='press-inner-navigation-items'>
              <li>
                <Link to={`/press/${prevProject && prevProject.id}/media_all`}>
                  <img
                    src='/media/icons/inclassica/arrow-left-black.svg'
                    alt='previous icon'
                  />
                  <span>{prevProject && prevProject.title}</span>
                </Link>
              </li>
              <li>
                <Link to={`/press/${nextProject && nextProject.id}/media_all`}>
                  <span>{nextProject && nextProject.title}</span>
                  <img
                    src='/media/icons/inclassica/arrow-right-black.svg'
                    alt='next icon'
                  />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

function mapState (state) {
  return {
    press_list: state.getPress,
    press_inner: state.getPressInner,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getPress: userActions.getPressData,
  getPressInnerData: userActions.getPressInnerData,
  getMeta: userActions.getMetaData,
};

PressInner.propTypes = {
  press_inner: PropTypes.object,
  press_list: PropTypes.array,
  getPressInnerData: PropTypes.func,
  getPress: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object,
};

PressInner.fetchMeta = () => actionCreators.getMeta('Press Accreditation Form');
PressInner.serverFetch = {
  getPress: () => actionCreators.getPress(),
  getPressInnerData: (path) => actionCreators.getPressInnerData(path),
};

export default connect(mapState, actionCreators)(PressInner);
